export default "__VITE_ASSET__b10e3d27__"